import Marquee from "react-fast-marquee";

const words = [
  "Residential",
  "Commercial",
  "Handyman",
  "Renovations",
  "Ground-up Builds",
  "24/7 Emergency",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="marquee-section"
      className="marquee-ribbon relative bg-black py-8"
    >
      <Marquee gradient={false} speed={28} pauseOnHover>
        {words.map((w, i) => (
          <span key={i} className="mx-10 flex items-center gap-10">
            <span className="font-editorial text-4xl italic text-white/85 md:text-6xl">
              {w}
            </span>
            <span className="inline-block h-2 w-2 rounded-full bg-[color:var(--accent)]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
